import { notifyError } from '../services/bugsnag'

type NotPromise<T> = T extends PromiseLike<unknown> ? never : T

const catchActionError = <Args extends unknown[], ReturnValue>(
  action: (...args: Args) => NotPromise<ReturnValue>,
) => {
  return (...args: Args) => {
    try {
      action(...args)
    } catch (error) {
      notifyError(error)
    }
  }
}

const catchAsyncActionError = <Args extends unknown[]>(
  action: (...args: Args) => Promise<void>,
) => {
  return async (...args: Args) => {
    try {
      await action(...args)
    } catch (error) {
      notifyError(error)
    }
  }
}

export { catchActionError, catchAsyncActionError }
